import React from 'react';

export const Footer = () => {
  return (
    <footer data-testid="footer" className="border-t border-gray-200 py-4 px-6 bg-white">
      <div className="container mx-auto">
        <div className="flex items-center justify-between">
          <span className="text-lg font-bold text-black">ArcheanX</span>
          <div className="flex items-center gap-6">
            <nav className="hidden md:flex items-center gap-6 text-sm">
              <a href="#home" className="text-gray-600 hover:text-orange-600 transition-colors">Home</a>
              <a href="#solution" className="text-gray-600 hover:text-orange-600 transition-colors">Solution</a>
              <a href="#platform" className="text-gray-600 hover:text-orange-600 transition-colors">Platform</a>
              <a href="#contact" className="text-gray-600 hover:text-orange-600 transition-colors">Demo</a>
            </nav>
            <span className="text-gray-500 text-sm">&copy; 2026 ArcheanX</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
